import { createContext } from "react";
import { ProductAttributes } from "../../../../Domains/Products/api/productJsonApi.ts";
import { OptionGroupAttributes } from "../../../../Domains/OptionGroups/api/optionGroupsApi.ts";

export type ProductData = PartialRecord<number, ProductAttributes>;
export type OptionGroupData = PartialRecord<number, OptionGroupAttributes>;

export const ProductOptionGroupDataContext = createContext<{
  productData: ProductData;
  optionGroupData: OptionGroupData;
  setProductData: (productData: ProductData) => void;
  setOptionGroupData: (optionGroupData: OptionGroupData) => void;
}>({
  productData: {},
  optionGroupData: {},
  setProductData: () => {},
  setOptionGroupData: () => {},
});
